import { ff } from '@atlassian/jira-feature-flagging';

export const CONTEXTUAL_BULK_OPS_ANALYTICS_CHANGES = 'contextual-bulkops-analytics-changes_bisrw';

export const isContextualBulkOpsAnalyticsChangesEnabled = () =>
	ff('contextual-bulkops-analytics-changes_bisrw');
